module.exports = __webpack_public_path__ + "img/banner.ee603740.png";